export default {
  state: {
    cabinList: [
      // 'First'
      'Economy',
      'PremiumEconomy',
      'Business',
      // 'PremiumBusiness',
      'First'
    ],
    includedLandTranspo: [],
    activeLeg: 'leg1',
    fetch: [],
    showFrontModal: false,
    flightPrice: {
      loading: false,
      error: ''
    },
    lastSelectedFlight: {
      leg1: {},
      leg2: {}
    },
    totalDiscount: 0,
    processingFlightSubmit: false,
    flightPending: false,
    bookingRef: {
      leg1: {
        bookingId: '',
        pnr: '',
        d2dId: ''
      },
      leg2: {
        bookingId: '',
        pnr: '',
        d2dId: ''
      }
    },
    rtConfirm: {
      show: false,
      activate: false
    },
    servicesPage: 10,
    serviceLegHighlight: true,
    apiType: '',
    minCabin: 'Economy',
    bookAsGuest: false,
    defaultCountry: 'US',
    reviewAction: ''
  },
  mutations: {
    setOthersData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    toggleIncludedLandTranspo (state, val) {
      let i = state.includedLandTranspo.indexOf(val)
      if (i > -1) state.includedLandTranspo.splice(i, 1)
      else state.includedLandTranspo.push(val)
    },
    removeFromFetch (state, val) {
      let i = state.fetch.indexOf(val)
      if (i > -1) state.fetch.splice(i, 1)
    },
    setLastSelectedFlight (state, data) {
      for (let field in data) {
        state.lastSelectedFlight[field] = data[field]
      }
    },
    setBookingRefData (state, data) {
      for (let field in data) {
        state.bookingRef[field] = data[field]
      }
    },
    setRtConfirmData (state, data) {
      for (let field in data) {
        state.rtConfirm[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/others.js